// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"d956e922","869":"1f4f2d96"}[chunkId] + ".chunk.js";
};